import React from 'react';
import orangeLogo from '../../assets/logo_thankfully_orange.png';
import requestButton from '../../assets/button_requestinvite.png';
import './RequestAccessButton.css';
import { Link } from 'react-router-dom';

const RequestAccessButton = () => {
    return (
        <div className="request-button-container" >
            <div className="request-logo-container">
                <div className="logo-header-container">
                    <img className="orange-logo" src={orangeLogo}/>
                    <h1 className="request-header-text">Get Thankfully</h1>
                </div>
                <Link to="/download">
                    <div className="request-app-button">
                        <img className="request-app-button-image" src={requestButton} />
                    </div>
                </Link>
            </div>
           <h2 className="launch-description">We're prepping for launch, but you can request access now to our invitation-only beta</h2>
        </div>
    )
}

export default RequestAccessButton;


// WEBPACK FOOTER //
// ./src/components/RequestAccessButton/RequestAccessButton.js